<template>
  <div class="job-list-container" id="list-container-template">
    <div class="total-count">총 <span>{{ totalCnt }}</span>건</div>
    <div class="no-data" v-if="totalCnt === 0">검색된 강좌가 없습니다.</div>
    <div class="job-card-grid new-type moreType" v-else>
      <edu-card v-for="(item, index) in displayedList" :key="index" :education="item"></edu-card>
    </div>

    <div class="button-area btn-load-more">
      <button type="button" @click="more" v-if="list.length < totalCnt">
        <i class="ico ico-plus"></i>
        더보기
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import EduCard from './EduCard.vue';

export default({
  name: 'list-container-template',
  props: ['educationKind', 'educationSearchDto'],
  components: {
    EduCard,
  },
  data() {
    return {
      page: 1,
      list: [],
      viewCount: 12,
      totalCnt: 0,
      isLoading: false,
    };
  },
  watch: {
    viewCount(newVal, oldVal) {
      // 더보기 버튼 클릭시에만 추가 로딩
      if (newVal > oldVal && this.list.length < this.totalCnt && !this.isLoading) {
        this.loadMoreData();
      }
    },
  },
  computed: {
    displayedList() {
      return this.list.slice(0, this.viewCount);
    },
  },
  methods: {
    getList() {
      if (this.isLoading) return Promise.resolve();

      this.isLoading = true;

      const params = {
        ...this.educationSearchDto,
        educationKind: this.educationKind,
        page: this.page,
      };

      return Axios.get('/api/lectures/list', { params })
          .then((response) => {
            const data = response.data;
            this.totalCnt = data.totalElements;

            const newList = data.content.map(item => ({
              ...item,
              linkUrl: `/education-detail.do?id=${item.id}&viewCount=${this.viewCount}&educationKind=${this.educationKind}`,
            }));

            if (this.page === 1) {
              this.list = newList;
            } else {
              this.list.push(...newList);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    calculateStatus(status, openDate, endDate, registStartDate) {
      if (status !== 'OPEN') return status;

      // Java LocalDateTime을 JavaScript Date로 변환
      let startDate = null;
      let endDateObj = null;

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      // openDate 처리
      if (openDate) {
        try {
          // ISO 형식 (예: "2025-10-08T00:00:00") 또는 날짜만 (예: "2025-10-08")
          if (openDate.includes('T')) {
            startDate = new Date(openDate);
          } else {
            startDate = new Date(openDate + 'T00:00:00');
          }
          // 날짜 부분만 비교하기 위해 시간 제거
          startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        } catch (e) {
          console.warn('openDate 파싱 실패:', openDate, e);
          startDate = null;
        }
      }

      // endDate 처리
      if (endDate) {
        try {
          if (endDate.includes('T')) {
            endDateObj = new Date(endDate);
          } else {
            endDateObj = new Date(endDate + 'T23:59:59'); // 종료일은 밤 11:59:59로 설정
          }
          endDateObj = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), endDateObj.getDate());
        } catch (e) {
          console.warn('endDate 파싱 실패:', endDate, e);
          endDateObj = null;
        }
      }

      // "251008" → "20251008"로 변환하여 Date 객체 생성
      const regStartYear = 2000 + parseInt(registStartDate.slice(0, 2));
      const regStartMonth = parseInt(registStartDate.slice(2, 4)) - 1; // 0-based month
      const regStartDay = parseInt(registStartDate.slice(4, 6));
      const regStartDate = new Date(regStartYear, regStartMonth, regStartDay);

      if (startDate && today < startDate) return "WAITING";
      if (endDate && endDate < today) return "CLOSED";
      if (!startDate && today < regStartDate) return "WAITING";

      return status;
    },
    loadMoreData() {
      this.page += 1;
      this.getList();
    },
    more() {
      this.viewCount += 8;
      const params = new URLSearchParams(window.location.search);
      params.set("viewCount", this.viewCount);

      history.replaceState(null, "", "?" + params.toString());
    },
    searchData() {
      const params = new URLSearchParams(window.location.search);
      params.set("viewCount", this.viewCount);
      params.set("state", this.educationSearchDto.state);
      params.set("cost", this.educationSearchDto.cost);
      params.set("term", this.educationSearchDto.term);
      params.set("type", this.educationSearchDto.type);
      params.set("orgCode", this.educationSearchDto.orgCode);

      history.replaceState(null, "", "?" + params.toString());
      this.list = [];
      this.viewCount = 12;
      this.page = 1;
      this.getList();
    },
    async loadUntilPage(targetPage) {
      /* eslint-disable no-await-in-loop */
      while (this.page <= targetPage) {
        // eslint-disable-next-line no-await-in-loop
        await this.getList();
        this.page += 1;
      }
      /* eslint-disable no-await-in-loop */
    },
    scrollToLastItem() {
      const index = this.viewCount - 1;

      const list = document.querySelectorAll('.job-card.moreType');

      if (list[index]) {
        list[index].scrollIntoView({
          behavior: 'auto',
          block: 'center'
        });
      }
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const viewCount = params.get('viewCount');

    if (viewCount) {
      this.viewCount = parseInt(viewCount, 10);

      const pageSize = 8;
      const targetPage = Math.ceil((this.viewCount - 12) / pageSize) + 1;

      this.page = 1;
      this.loadUntilPage(targetPage).then(() => {
        this.$nextTick(() => {
          this.scrollToLastItem();
        });
      });
    } else {
      this.getList();
    }
  },
});
</script>



// WEBPACK FOOTER //
// EduCardListMoreType.vue?bfb68d86